/**
 * @file ValueGrid.tsx
 * @description Value proposition grid for Ultimind home page.
 */

/**
 * ValueGrid component highlights core enterprise benefits of Ultimind.
 */
export function ValueGrid() {
  const items = [
    {
      title: 'From generalist to team of experts',
      body:
        'Replace single-agent bottlenecks with role-based, rule-based, and model-based collaboration strategies.',
    },
    {
      title: 'Native to enterprise systems',
      body:
        'Deep integration with CRM, ERP, low-code, and workflow platforms to automate cross-system processes.',
    },
    {
      title: 'Secure by design',
      body:
        'Fine-grained permissioning, audit logs, and policy guards ensure compliant use of Large Language Models.',
    },
    {
      title: 'Faster time to production',
      body:
        'Visual orchestration of multi-agent workflows reduces implementation cycles from months to days.',
    },
  ]

  return (
    <section className="bg-slate-950">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <h2 className="text-center text-2xl font-semibold tracking-tight text-slate-50 md:text-3xl">
          Agentic AI built for real-world enterprises
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center text-sm text-slate-300 md:text-base">
          Ultimind combines advanced multi-agent research with decades of
          enterprise system experience to deliver reliable AI co-workers.
        </p>
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {items.map((item) => (
            <div
              key={item.title}
              className="rounded-2xl border border-slate-800 bg-slate-900/60 p-5 shadow-sm shadow-sky-900/40"
            >
              <h3 className="text-sm font-semibold text-sky-300 md:text-base">
                {item.title}
              </h3>
              <p className="mt-2 text-xs text-slate-300 md:text-sm">
                {item.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
